
<script>
    export default {
        props: ['berita', 'textColor', 'meta']
    };
</script>
<template>
    <div class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view">
        <div class="blog-post-slider__image section-space--bottom--30">
            <router-link :to="`berita-detail${meta.preview}id=${berita.url}`">
                <img :src="berita.image" class="img-fluid rounded" alt="blog-image">
            </router-link>
        </div>
        <div class="blog-post-slider__content">
            <p class="post-date">{{ berita.date }}</p>
            <h3 class="post-title">
                <router-link :to="`berita-detail${meta.preview}id=${berita.url}`">{{ berita.title }}</router-link>
            </h3>
            <p class="post-excerpt">{{ berita.body.replace(/<\/?[^>]+(>|$)/g, "").substring(0,100) }}</p>
            <router-link :to="`berita-detail${meta.preview}id=${berita.url}`" class="font-weight-bold" :class="textColor">Baca Selengkapnya >></router-link>
        </div>
    </div>
</template>